import { atom, selector, useRecoilState } from 'recoil'
import { IDeposit } from '../types/types'
import { api } from '../utils/api'

export const fetchDeposits = async (): Promise<IDeposit[]> => {
  const { data } = await api.get('/deposits')
  return data.deposits
}

export const depositsState = atom<IDeposit[]>({
  key: 'depositsState',
  default: selector({
    key: 'depositsState/Default',
    get: async (): Promise<IDeposit[]> => fetchDeposits(),
  }),
})

/**
 * Add a new deposit to the list of deposits
 */
export const useAddDeposit = () => {
  const [deposits, setDeposits] = useRecoilState(depositsState)

  const addDeposit = (deposit: IDeposit) => {
    setDeposits([...deposits, deposit])
  }

  return addDeposit
}

export const useDeleteDeposit = () => {
  const [deposits, setDeposits] = useRecoilState(depositsState)

  const deleteDeposit = async (depositId: string) => {
    const response = await api.delete(`/deposit/${depositId}`)

    if (response.status === 200) {
      setDeposits(deposits.filter((item) => item.id !== depositId))
    }
  }

  return deleteDeposit
}